/**
 * InteractableID enum - All interactable definition IDs
 */
export enum InteractableID {
    Door = 'door',
    LockedDoor = 'locked_door',
    BossDoor = 'boss_door',
    PresentChest = 'present_chest',
    Stocking = 'stocking',
    ChristmasTree = 'christmas_tree',
    Fireplace = 'fireplace',
    Bookshelf = 'bookshelf',
    Anvil = 'anvil',
    AlchemyPot = 'alchemy_pot',
    SleighStation = 'sleigh_station',
    SecretDoor = 'secret_door',
    DestructibleWall = 'destructible_wall',
    StairsDown = 'stairs_down',
    StairsUp = 'stairs_up',
    Chasm = 'chasm',
    CHEST = 'chest',
    TREASURE_CHEST = 'treasure_chest',
    SHOP_COUNTER = 'shop_counter',
    WORKBENCH = 'workbench',
    TRAP = 'trap',
    HIDDEN_DOOR = 'hidden_door',
    TRIGGER_PLATE = 'trigger_plate',
    LEVER = 'lever',
    PRESSURE_PLATE = 'pressure_plate',
    PUZZLE_CHEST = 'puzzle_chest',
    ALTAR = 'altar',
    BOSS_CHEST = 'boss_chest',
    FROZEN_CHEST = 'frozen_chest',
    ICE_SHRINE = 'ice_shrine',
    CRYSTAL_FORMATION = 'crystal_formation',
    CORRUPTED_TREE = 'corrupted_tree',
    EVIL_ALTAR = 'evil_altar',
    TRAPPED_CHEST = 'trapped_chest',
    BONE_PILE = 'bone_pile',
    Table = 'table',
    Bed = 'bed',
    KeyGold = 'key_gold',
    SlipperyIce = 'slippery_ice',
    BreakableIce = 'breakable_ice',
    SummoningCircle = 'summoning_circle',
    CandleStand = 'candle_stand',
    Campfire = 'campfire',
    WallTorch = 'wall_torch',
}
